module.exports = __webpack_public_path__ + "static/media/Coins.32f0b8bf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Icons/Coins.svg
// module id = 669
// module chunks = 0